import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import DataTable from "../../../../Common/Components/DataTable";
import Form from "../../../../Common/Components/Form";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import { useRules } from "../Hooks";
import { input } from "./Create";

const RulesList = () => {
  const {
    loading,
    getData,
    data,
    deleteRole,
    form,
    setForm,
    update,
    navigate,
  } = useRules();
  useEffect(() => {
    getData();
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست نقش ها</title>
      </Helmet>

      <DataTable
        filter={true}
        loading={loading.get}
        heads={[
          {
            title: "عنوان",
            key: "title",
          },

          {
            title: "نوع",
            key: "type",
            type: "enum",
            enum: {
              admins: "ادمین",
              users: "کاربر",
            },
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },

          {
            title: "تاریخ ایجاد",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="نقشی یافت نشد"
        list={data.data}
        data={data}
        function={getData}
        currentPage={data.current_page}
        header=" لیست نقش ها"
        textbtn="ایجاد نقش"
        linkbtn="/Admin/Rules/Create"
        links={[
          {
            function: selected => {
              deleteRole({ role_id: selected[0] });
            },
            color: "danger",
            size: "col",
            html: "حذف",
            multi: true,
            type: "delete",
          },

          {
            function: selected => {
              setForm({ role_id: selected[0] });
            },
            color: "info",
            size: "col",
            html: "ویرایش",
            type: "edit",
          },
          {
            function: selected => {
              navigate(
                `/Admin/Rules/Update/${selected[0]}-${
                  data &&
                  data.data &&
                  data.data.filter(item => {
                    if (item.id == selected[0]) {
                      return {
                        ...item,
                      };
                    }
                  })[0].type
                }`,
                {
                  state: {
                    data:
                      data &&
                      data.data &&
                      data.data.filter(item => {
                        if (item.id == form.role_id) {
                          return {
                            ...item,
                          };
                        }
                      })[0],
                  },
                }
              );
            },
            color: "info",
            size: "col",
            html: "ایجاد دسترسی",
            type: "go",
            main: true,
          },
        ]}
      />

      <CustomModal
        show={form.role_id}
        handleClose={() => {
          setForm({ role_id: false });
        }}
        header={"ویرایش نقش"}
      >
        <Form
          loading={loading.update}
          form={input}
          btnName={"ویرایش نقش"}
          value={
            data &&
            data.data &&
            data.data.filter(item => {
              if (item.id == form.role_id) {
                return {
                  ...item,
                };
              }
            })[0]
          }
          edit={true}
          submit={update}
        />
      </CustomModal>
    </Fragment>
  );
};

export default RulesList;
